module.exports = __webpack_public_path__ + "img/botones_especiales.6f75499a.jpg";